export const golf_polo = {
  msrp: 59.99,
  infoLink: 'https://www.teamtriton.com/stroker-custom-golf-polo.html',
  items: [
    {
      number: 'GP97',
      hasModel: false,
    },
    {
      number: 'GP98',
      hasModel: false,
    },
    {
      number: 'GP99',
      hasModel: false,
    },
    {
      number: 'GP100',
      hasModel: false,
    },
    {
      number: 'GP101',
      hasModel: false,
    },
    {
      number: 'GP102',
      hasModel: false,
    },
    {
      number: 'GP103',
      hasModel: false,
    },
    {
      number: 'GP104',
      hasModel: false,
    },
    {
      number: 'GP105',
      hasModel: false,
    },
    {
      number: 'GP106',
      hasModel: false,
    },
    {
      number: 'GP107',
      hasModel: false,
    },
    {
      number: 'GP108',
      hasModel: false,
    },
    {
      number: 'GP109',
      hasModel: false,
    },
  ],
};
